import React, { useMemo } from 'react';

import { Chip, Tooltip } from '@mui/material';

// Component to display confidence score for a mapping
export default function MappingConfidence({
  sourceRoomName,
  propertyRoomName,
  mlMatchingCandidates,
}: {
  sourceRoomName?: string;
  propertyRoomName: string;
  mlMatchingCandidates?: Record<string, import('~/services/BedbankService').SourceRoomMLResult>;
}) {
  const confidence = useMemo(() => {
    if (!mlMatchingCandidates || !sourceRoomName) {
      return null;
    }

    const sourceRoomResult = mlMatchingCandidates[sourceRoomName];

    if (!sourceRoomResult?.candidates || sourceRoomResult.candidates.length === 0) {
      return null;
    }

    const matchingCandidate = sourceRoomResult.candidates.find(
      (candidate) => candidate.masterRoomName === propertyRoomName,
    );

    if (!matchingCandidate) {
      return null;
    }

    return {
      score: matchingCandidate.score,
      threshold: sourceRoomResult.confidenceThreshold,
    };
  }, [mlMatchingCandidates, sourceRoomName, propertyRoomName]);

  if (!sourceRoomName || !confidence) {
    return null;
  }

  const confidencePercent = (confidence.score * 100).toFixed(1);
  const isHighConfidence = confidence.score > confidence.threshold;

  return (
    <Tooltip title={`Match confidence: ${confidencePercent}%`}>
      <Chip label={`${confidencePercent}% match`} color={isHighConfidence ? 'success' : 'warning'} size="small" />
    </Tooltip>
  );
}
